import { Component, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core'

//import { StatusBar } from '@ionic-native/status-bar';
//import { SplashScreen } from '@ionic-native/splash-screen';
//import { Device } from '@ionic-native/device';
import { AlertController, ModalController, Content, ToastController } from 'ionic-angular'

import { Platform } from 'ionic-angular'

import { MenuController } from 'ionic-angular'
import { Nav } from 'ionic-angular'
import { Events } from 'ionic-angular'

//import { IonPullUpFooterState } from 'ionic-pullup';

import { LoginPage } from '../pages/login/login'
import { HistoryPage } from '../pages/history/history'
import { ControlPanelPage } from '../pages/control-panel/control-panel'
import { CondominiumShowPage } from '../pages/condominium-show/condominium-show'
import { DeviceEditPage } from '../pages/device-edit/device-edit'
import { DeviceShowPage } from '../pages/device-show/device-show'


import { Condominium, Device, DeviceType, DomainEvents, User, DeviceCache, SignalingMessage } from '../models/models'
import { Logger } from '../util/logger/logger'
//import { JL } from 'jsnlog';


//import { CondominiumIntercomPage } from '../pages/condominium-intercom/condominium-intercom';
//import { DashboardPage } from '../pages/dashboard/dashboard';

import { AddressProvider } from '../providers/address/address'
import { AuthProvider } from '../providers/auth/auth'
import { CondominiumProvider } from '../providers/condominium/condominium'
import { ConfigProvider } from '../providers/config/config'
import { DeviceProvider } from '../providers/device/device'
import { FlavourProvider } from '../providers/flavour/flavour'
import { LocationProvider } from '../providers/location/location'
import { HousingUnitProvider } from '../providers/housing-unit/housing-unit'
import { MessageProvider } from '../providers/message/message'
import { UserProvider } from '../providers/user/user'
import { WebrtcProvider } from '../providers/webrtc/webrtc'

/*
PLUGIN NATIVI
*/
import { OpenNativeSettings } from '@ionic-native/open-native-settings'
import { CreditsModalPage } from '../pages/credits-modal/credits-modal'
import { LocalNotifications } from '@ionic-native/local-notifications'
import { TextToSpeech } from '@ionic-native/text-to-speech'
import { SecurityCamProvider } from '../providers/security-cam/security-cam'
import { CallPage } from '../pages/call/call'
import { InterappProvider } from '../providers/interapp/interapp'

import { SignalingSocketIoProvider } from '../providers/signaling/socket_io'
import { AndroidBridgeProvider } from '../providers/android/android-bridge'

declare var window: any


@Component({
	templateUrl: 'app.html',
	providers: [
		AddressProvider,
		AuthProvider,
		ConfigProvider,
		CondominiumProvider,
		FlavourProvider,
		DeviceProvider,
		HousingUnitProvider,
		LocationProvider,
		MessageProvider,
		WebrtcProvider,
		UserProvider
	]//Provider condivisi
})
export class ClientApp {
	@ViewChild(Nav) nav: Nav
	@ViewChildren(Content) content: Content

	public accordionMenuItem: string = null;


	get rootPage(): any {
		let root = this.flavours.actualRoot
		return root ? root : LoginPage
	}

	public get actualDevice(): Device {
		//console.log('Dispositivo corrente:', DeviceProvider.actual)
		return DeviceProvider.actual
	}

	public appName = ConfigProvider.APPLICATION_NAME;

	/**
	Se true il login è consentito solo a superuser
	*/
	public get isLoginSuperuserOnly() {
		let actualType = this.devices.actualType
		return actualType == DeviceType.DASHBOARD || actualType == DeviceType.INTERCOM
	}
	/**
	Verifica se l'utente può uscire dall'app


	Su bacheca, citofono e browser configurati, non disponibile
	Se non autenticato, non disponibile
	*/
	public get canExit() {
		//varia in base al tipo di dispositivo configurato o indovinato
		switch(this.devices.actualType) {
			case DeviceType.BROWSER:
				//browser mai
				return false
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				//bacheca e citofono dipende dal ruolo dell'autenticato
				return this.auth.hasRole(['is_admin', 'is_operator'])
			case DeviceType.SMARTPHONE:
			default:
				//altrimenti si
				return true
		}
	}

	constructor(
		public android_bridge:AndroidBridgeProvider,
		public auth: AuthProvider,
		public devices: DeviceProvider,
		public flavours: FlavourProvider,
		public securityCam: SecurityCamProvider,
		public webrtc: WebrtcProvider,//riferimanto per avviare auto-inizializzazione

		public alertCtrl: AlertController,
		private changeDetector: ChangeDetectorRef,
		public events: Events,
		public interapp: InterappProvider,//TODO Rimuovere dopo test di intercomunicazione
		public localNotifications: LocalNotifications,
		public menu: MenuController,
		public modalCtrl: ModalController,
		public openNativeSettings: OpenNativeSettings,
		public platform: Platform,
		private signaling: SignalingSocketIoProvider,
		//public splashScreen: SplashScreen,
		//public statusBar: StatusBar,
		public textToSpeech: TextToSpeech,
		public toastCtrl: ToastController
	) {
		//inizio area logger
		Logger.enter('[ClientApp.new()] Costruttore istanza App')
		let self = this

		setInterval(() => {
			console.clear()
			console.info('Console ripulita automaticamente.')
		}, 60 * 60 * 1000)//Per evitare abuso di memoria, ogni ora cancella la console


		//this.window = window;

		/*
		Inizializzazione quando la piattaforma è pronta
		*/
		console.time('new ClientApp.platform.ready()')
		platform.ready().then(type => {
			console.timeEnd('new ClientApp.platform.ready()')//fine pre-inizializzazione
			console.time('ClientApp.platform.ready().then().hideSplashScreen()')//avvio splash screen

			console.group('ClientApp.platform.ready(): Piattaforma avviata, tipo di piattaforma:', type)

			let initializations: Promise<any>[] = []


			//registra i listener di eventi globali

			/*
			Azioni da effettuare al login utente

			ATTENZIONE: QUESTO VA FATTO DA LOGIN PAGE IN QUANTO PUO ESSERE UN LOGIN TEMPORANEO, NON DECOMMENTARE NE CANCELLARE, COME PROMEMORIA

			self.events.subscribe(DomainEvents.USER_LOGIN, (user: User, time) => {

			console.debug('ClientApp.events.on(USER_LOGIN) : Ricevuto evento di avvenuto login');
			//quando fa login con sessione reimposta la root
			let root = self.flavours.actualRoot
			console.debug('[ClientApp.events,on(USER_LOGIN)] Vado alla root: ', root)
			self.nav.setRoot(root);
		});
		*/


			/*
			LOGOUT AUTOMATICO DOPO X SECONDI SU BACHECA E CITOFONO, DEVE STARE QUI PER NON RICHIEDERE RIFERIMENTO INCROCIATO TRA I PROVIDER
			*/
			self.nav.viewDidEnter.subscribe((view) => {
				let actualType = self.devices.actualType
				console.debug('[ClientApp.nav.viewDidEnter()] Entrato nella vista:', view.instance.constructor.name)
				switch(actualType) {
					default://null?
					case DeviceType.BROWSER://nada
					case DeviceType.SMARTPHONE://nada
						break
					case DeviceType.INTERCOM://countdown logout e risotrno alla root
					case DeviceType.DASHBOARD://countdown logout e risotrno alla root
						//TODO Timeout per ritorno alla root

						if(self.auth.isAuth) {
							console.debug('Utente autenticato su citofono o bacheca, (re)imposto il timeout di logout...')
							self.auth.setLogoutTimeout()
						}
						break
				}
			})

			//registra gli eventi prima dell'eventuale autologin
			self.registerGlobalEventListeners()

			//autologin necessario prima dello splash, eventualmente va alla home
			initializations.push(auth.autologin())

			//finite le inizializzazioni necessarie rimuove lo splash e prosegue
			Promise.all(initializations).then((values) => {
				console.debug('[ClientApp.platform.ready().initializations.then()] Inizializzazioni terminate, aggiorno la root e nascondo lo splash screen', values)

				//imposta la root post-inizializzazione
				self.nav.setRoot(self.flavours.actualRoot)

				self.hideSplashScreen()
			}).catch(errors => {
				console.error('[ClientApp.platform.ready().initializations.catch()] Errore durante le inizializzazioni, aggiorno la root e nascondo lo splash screen', errors)
				//TODO Pagina di errore, eventuale timeout di reset
				self.hideSplashScreen()
			})


			//incondizionata a tutti, poichè eventualmente dopo si possono collegare microfono o webcam
			devices.requestPermissions([
				devices.androidPermissions.PERMISSION.RECORD_AUDIO,
				devices.androidPermissions.PERMISSION.MODIFY_AUDIO_SETTINGS,
				devices.androidPermissions.PERMISSION.CAMERA
			]).then(() => {
				console.info('Fine richiesta permessi')
			})

			//attivazione menù
			menu.enable(true)

			//inizializzazioni native
			if(self.platform.is('cordova')) {
				console.info("Piattaforma cordova: Attivo le funzioni native..")

				/**
				Al click sulle notifiche va alla home e riporta in primo piano
				*/
				console.debug('Gestione del click sulle notifiche..')
				self.localNotifications.on('click').subscribe(() => {
					console.debug('[ClientApp.localNotifications.on("click")] Tap sulla notifica, reimposo la home e riporto in primo piano..')
					self.nav.setRoot(self.flavours.actualRoot)
					self.devices.moveToForeground()
				})

				/*
				Intercetta il bottone "back" a seconda della modalità attuale
				*/
				console.debug("Gestione del tasto 'indietro'..")
				platform.registerBackButtonAction((event) => {
					console.group('new ClientApp().platform.registerBackButtonAction(): Premuto il tasto indietro..')
					if(event && event.preventDefault) {
						event.preventDefault()//Esce solo programmaticamente
					}

					if(self.menu.isOpen()) {
						console.log('Menù aperto, chiudo il menù...')
						self.menu.close()
					} else if(self.nav.canGoBack()) {
						console.log('Individuata pagina precedente, eseguo self.nav.pop()..')
						self.nav.pop()
					} else if(self.devices.isAlwaysFront) {
						console.log('App sempre in primo piano attiva, ignorato l\'evento.')
					} else {
						console.log('Pagina root su dispositivo utente, uscita con conferma..')
						let alert = this.alertCtrl.create({
							title: 'Conferma uscita',
							message: 'Vuoi veramente uscire dall\'app?',
							buttons: [
								{
									text: 'Cancel',
									role: 'cancel',
									handler: () => {
										console.log('Uscita non confermata')
									}
								},
								{
									text: 'Esci',
									handler: () => {
										console.log('Uscita confermata, invio l\'applicazione in background..')
										self.devices.close_app()
									}
								}
							]
						})
						alert.present()
					}


					return false
				}, 999)//priorità massima
			}

			self.devices.moveToForeground()//XXX ? è necessario?
		})

		//fine area logger
		Logger.exit()
	}

	/**
	Nascondel o splash, a fine inizializzazione
	*/
	private hideSplashScreen() {
		let splash = document.getElementById('splash-screen')
		console.debug('[ClientApp.hideSplashScreen()] Rimuovo splash screen')

		//1s per finire l'eventuale sostituzione della root
		setTimeout(() => {
			splash.style.opacity = '0'
		}, 1000)
		//1 altro secondo per l'opacity che sparisce, poi riumuove del tutto
		setTimeout(() => {
			splash.remove()
		}, 2000)

		console.groupEnd()//fine platform.ready()
		console.timeEnd('ClientApp.platform.ready().then().hideSplashScreen()')//rimozione splash screen
		this.changeDetector.detectChanges()
	}

	/**
	Sblocca l'app ed esce, funziona solo per nativo
	*/
	public exit() {
		console.debug('[ClientApp.exit()] Richiesta di uscita dal programma..')
		this.dismissMenu()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Uscire dall'app?",
			message: "Vuoi davvero uscire dall'app? Non riceverai più chiamate, messaggi o notifiche fino al prossimo lancio dell'app",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Esci',
					handler: () => {
						//self.platform.exitApp()
						self.devices.close_app()
					}
				}
			]
		})
		confirm.present()
	}

	/**
	Chiude il menù e gli accordion
	*/
	public dismissMenu() {
		this.menu.close()
		this.toggleAccordionMenuItem()
	}


	public goToCondominiumShow(condominium: Condominium) {
		this.dismissMenu()
		this.nav.push(CondominiumShowPage, { condominium: condominium })
	}

	public goToControlPanel() {
		this.dismissMenu()
		console.debug('[ClientApp.goToControlPanel()] Ritorno al pannello di controllo')
		this.nav.setRoot(ControlPanelPage)
	}

	public goToDeviceEdit(device: Device) {
		this.dismissMenu()
		this.nav.push(DeviceEditPage, { device: device })
	}

	public goToDeviceShow(device: Device) {
		this.dismissMenu()
		this.nav.push(DeviceShowPage, { device: device })
	}

	public goToHistoryPage() {
		this.dismissMenu()
		this.nav.push(HistoryPage)
	}

	public login() {
		this.dismissMenu()
		this.auth.logout()//Assicurati il logout, si sa mai
		console.info('[ClientApp.login()] Impilo la schermata di login')
		//let self = this;
		this.nav.push(LoginPage, {
			type: 'email_password'/* XXX La possibilità di autenticarsi sul dispositivo è già controllata lato server, qui basta adeguare le UI
	, nextGuard: (auth: AuthProvider) => {
	//su bacheca e citofono solo operatori e admin possono autenticarsi
	switch (self.devices.actualType) {
	case DeviceType.DASHBOARD:
	case DeviceType.INTERCOM:
	return auth.hasRole(['is_admin', 'is_operator'])
	default:
	return true;
}
}
*/
		})
	}
	/*
	Prima cambia pagina e poi fa logout, per evitare errori di valutazione auth.user sulla pagina attuale
	*/
	public logout() {
		this.dismissMenu()
		this.auth.logout()
		//NOTE in teoria qua non serve perchè reimposta la root su evento logout
		//this.changeDetector.detectChanges()
	}

	/**
	DOVREBBE aprire le impostazioni di sistema

	Impostazioni apribili

	"about", // ios	"accessibility", // ios, android	"account", // ios, android	"airplane_mode", //ios, android	"apn", // android	"application_details", // ios, android"application_development",// android	"application", // android	"autolock", // ios"battery_optimization", // android
	"bluetooth", // ios, android	"browser", // ios
	"castle", // ios "captioning", // android	"cast", // android	"cellular_usage", // ios "configuration_list",// ios
	"data_roaming", // android	"date", // ios, android	"display", //ios, android	"dream", // android
	"facetime", // ios
	"home", // android
	"keyboard", // ios,android	"keyboard_subtype", // android
	"locale", // ios, android	"location", // ios,android	"locations", // ios
	"manage_all_applications", // android	"manage_applications", //android	"memory_card", // android	"music", // ios	"music_equalizer", // ios"music_volume",// ios
	"network", // ios, android	"nike_ipod", // ios	"nfcsharing", //android	"nfc_payment", // android	"nfc_settings", // android	"notes", // ios"notification_id", // ios
	"passbook", // ios	"phone", // ios	"photos", // ios	"print",//android	"privacy", // android
	"quick_launch", // android
	"reset", // ios"ringtone",//ios
	"search", // ios, android	"security", // android "settings", // ios, android	"show_regulatory_info",	"sound", // ios, android "software_update", // ios	"storage", // ios, android	"store", // ios, android	"sync", //android
	"tethering", // ios	"twitter", // ios	"touch", // ios
	"usage", // ios, android "user_dictionary", // android
	"video", // ios	"voice_input", // android	"vpn", // ios
	"wallpaper", // ios	"wifi_ip", // android	"wifi", // ios, android	"wireless" // android
	*/
	public openSettings(page = 'settings') {
		console.debug("ClientApp.openSettings() : Apertura impostazioni di sistema alla pagina '" + page + "'")
		this.openNativeSettings.open(page)
	}


	/**
	Registra tutti i listener globali di eventi
	*/
	public registerGlobalEventListeners() {
		console.debug('ClientApp.registerGlobalEventListeners(): Sottoscrizione dei gestori di eventi globali..')
		let self = this

		//logout su evento richiedente, dopo aver filtrato
		this.events.subscribe(DomainEvents.USER_LOGOUT_REQUESTED, (request: SignalingMessage) => {
			if(self.auth.isAuth && self.auth.user.id == request.userId && (!request.deviceIdentifier ||
				ConfigProvider.generatePeerIdDevice(DeviceProvider.identifier) != request.deviceIdentifier)) {
				console.debug('[AuthProvider.events.on(USER_LOGOUT_REQUESTED)] Richiesta accolta, eseguo il logout')
				self.auth.logout()

				let toast = self.toastCtrl.create({
					message: "Disconnesso: Hai effettuato il login su un altro dispositivo",
					position: 'middle',
					duration: 3000,
					//cssClass: "danger"
				})
				toast.present()
			} else {
				console.debug('[AuthProvider.events.on(USER_LOGOUT_REQUESTED)] Richiesta ignorata')
			}
		})

		//NOTE esiste già in devices un polling configurazione dispositivo

		/*
		Al logout aggiorna la root
		Il login invece è gestito dalla pagina di login
		*/
		self.events.subscribe(DomainEvents.USER_LOGOUT, (_user: User, _time) => {
			let root = self.flavours.actualRoot
			console.debug('[ClientApp.events.on(USER_LOGOUT)] Logout: Reset della root per il dispositivo corrente', DeviceProvider.actual, root)
			self.nav.setRoot(root)
			self.changeDetector.detectChanges()
		})

		/**
		Chiamata in arrivo
		*/
		this.events.subscribe(DomainEvents.ServerSignalingCallIncoming, (callInit: SignalingMessage) => {
			console.debug("[ClientApp.events.on(ServerSignalingCallIncoming)] Ricevuto CALL_INIT, Inizializzo la connessione ed apro la pagina di chiamata in arrivo..")
			switch(self.devices.actualType) {
				case DeviceType.BROWSER:
				case DeviceType.SMARTPHONE:
					self.devices.initIceServers().then(() => {//aggiorna i server ICE
						//apro la pagina di chiamata in arrivo
						self.nav.push(CallPage, { callInit: callInit })
					})
				default:
					console.debug('[ClientApp.events.on(ServerSignalingCallIncoming)] Ricevuta richiesta di chiamata su citofono o bacheca, ignorata.')
					break
			}
		})

		//gestione richieste apertura portone
		self.events.subscribe(DomainEvents.OPEN_DOORWAY_REQUEST, (request: SignalingMessage) => {
			console.debug('[ClientApp.events.on(OPEN_DOORWAY_REQUEST)] Ricevuta richiesta di apertura portone')
			//self.interapp.openDoorway()
			//2025 migrato ad android bridge
			self.android_bridge.send_impulse().then(result => {
				if(result.message !== 'ok') {
					console.warn('Tentativo di aprire il portone fallito')
					self.signaling.sendOpenedDoorway(request, false)
					let toast = self.toastCtrl.create({
						message: "Errore di sistema aprendo il portone",
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					})
					toast.present()
				} else {
					self.signaling.sendOpenedDoorway(request, true)
					let toast = self.toastCtrl.create({
						message: "Apertura portone",
						position: 'middle',
						duration: 3000,
						//cssClass: "light"
					})
					toast.present()
				}
			}).catch(e => {
				console.error('Errore cercando di aprire il portone su richiesta remota', e)
				self.signaling.sendOpenedDoorway(request, false)
				let toast = self.toastCtrl.create({
					message: "Errore di sistema aprendo il portone",
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			})
		})

		//gestione risposta a richiesta apertura portone
		self.events.subscribe(DomainEvents.OPEN_DOORWAY_RESPONSE, (response: SignalingMessage) => {
			console.debug('[ClientApp.events.on(OPEN_DOORWAY_RESPONSE)] Ricevuto esito apertura portone')
			if(response.data) {
				let toast = self.toastCtrl.create({
					message: "Portone aperto",
					position: 'middle',
					duration: 3000,
					//cssClass: "light"
				})
				toast.present()
			} else {
				let toast = self.toastCtrl.create({
					message: "Si è verificato un problema con l'apertura portone",
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			}
		})


		/*
		Quando carica per la prima volta o cambia il tipo del dispositivo aggiorna root e modalità di funzionamento
		Nota: il device deve essere caricato post inizializzazione
		*/
		self.events.subscribe(DomainEvents.DEVICE_ACTUAL_UPDATED, (device: Device, _time, previous: Device) => {
			console.group('[ClientApp.events.on(DEVICE_ACTUAL_UPDATED)] Aggiornamento del dispositivo, eventuale sostituzione della pagina iniziale', device)

			/*
			Sostituzione della classe del tema se presente
			*/
			let theme = 'default'
			if(device) {
				if(device.theme) {
					theme = device.theme
				} else if(device.condominium && device.condominium.theme) {
					theme = device.condominium.theme
				}
			}

			//recupera tutte le classi eccetto quella del tema
			var bodyClasses = document.body.className.split(" ").filter(c => { return c.lastIndexOf("theme_", 0) !== 0 })
			//sostituisce col nuovo tema
			bodyClasses.push("theme_" + theme)
			//sostituisce le classi
			document.body.className = bodyClasses.join(" ").trim()

			if(self.auth.isAuth) {
				console.debug('[ClientApp.events.on(DEVICE_ACTUAL_UPDATED)] Utente autenticato, non reimposto la pagina iniziale')
				return
			}

			let actualType = device ? device.type : null
			let previousType = previous ? previous.type : null

			if(actualType === previousType) {
				console.debug("[ClientApp.events.on(DEVICE_ACTUAL_UPDATED)] Tipo non modificato, non reimposto la pagina iniziale")
				//eventualmente rilegge valori nelle UI prima di uscire
				self.changeDetector.detectChanges()
				return
			}

			let root = self.flavours.actualRoot
			console.debug('[ClientApp.events.on(DEVICE_ACTUAL_UPDATED)] Reimposto la pagina inizale per il tipo: ' + actualType, root)

			//se è cambiato il tipo di dispositivo reimposta la root
			self.nav.setRoot(root)
			console.groupEnd()
		})
	}

	/*
	Rilegge i dati del dispositivo corrente
	*/
	public reloadActualDevice() {
		this.dismissMenu()
		this.devices.getActual(null, DeviceCache.REMOTE).catch(error => { console.error('Errore caricando i dati del dispositivo corrente', error) })
	}

	/*
	Visualizza il modale con i credits
	*/
	public showCredits() {
		let creditsModal = this.modalCtrl.create(
			CreditsModalPage
		)
		creditsModal.present()
	}


	/**
	Cancella configurazione attuale previa conferma
	*/
	public showDestroyActualDeviceConfirm() {
		this.dismissMenu()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Eliminare le impostazioni del dispositivo dal server?",
			message: "Vuoi davvero eliminare la configurazione remota di questo dispositivo?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.devices.destroy(DeviceProvider.actual).then((_success: boolean) => {
							self.devices.getActual().then(device => {
								if(device) console.warn('Trovata copia della configurazione appena eliminata', device)
							}).catch(error => {
								console.error('Errore ricaricando la configurazione del dispositivo attuale', error)
							})
						}).catch(error => {
							console.error('Errore cancellando la configurazione del dispositivo attuale', error)
						})
					}
				}
			]
		})
		confirm.present()
	}

	/**
	Apre popup con identificativo dispositivo
	*/
	public showIdentifier() {
		this.dismissMenu()
		this.devices.getIdentifier().then(identifier => {
			if(identifier) {
				alert(identifier)
			} else {
				alert('Impossibile generare un identificativo per il dispositivo')
			}
		})
	}

	/**
	Azzera identificativo attuale
	*/
	public showResetIdentifierConfirm() {
		this.dismissMenu()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Rigenerare l'identificativo del dispositivo?",
			message: "Vuoi davvero rigenerare l'identificativo del dispositivo?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Rigenera',
					handler: () => {
						self.devices.resetIdentifier()
					}
				}
			]
		})
		confirm.present()
	}

	/**
	Avvia il configuratore BTSwitch
	DEPRECATED
	*/
	/*
	public startBTSwitch() {
		this.dismissMenu()
		//invia tramite il bridge android
		this.android_bridge.send_impulse().then((result: AndroidMessage) => {
			console.debug("Apertura eseguita", result)
			
			let toast = this.toastCtrl.create({
				message: "Aperto.",
				position: 'middle',
				duration: 3000,
				//cssClass: "danger"
			})
			toast.present()
		}).catch(error => {
			console.error("Errore eseguendo l'apertura", error)
			let toast = this.toastCtrl.create({
				message: "Errore",
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		})
		//Vecchio modello, interapp
		//this.interapp.startBTSwitch()
	}
*/
	/**
	Genera lato serve una configurazione per il dispositivo attuale
	*/
	public storeActualDevice() {
		this.dismissMenu()
		this.devices.storeActual().then((device: Device) => {
			console.debug("Configurazione attuale salvata se non presente", device)
		}).catch(error => {
			console.error("Errore salvando la configurazione se non presente", error)
		})
	}

	/**
	Legge un testo
	*/
	public testToSpeech() {
		if(this.devices.guessType() == DeviceType.BROWSER) {//nessuna azione per i browser
			return
		}

		this.textToSpeech.speak({
			text: 'Buongiorno',
			locale: 'it-IT'
		}).then(() => console.log('Testo di benvenuto letto'))
			.catch((reason: any) => console.log('Errore leggendo il testo', reason))
	}


	/**
	Imposta l'item visibile nell'accordion menu
	*/
	public toggleAccordionMenuItem(accordionMenuItem = null) {
		if(this.accordionMenuItem == accordionMenuItem) {
			this.accordionMenuItem = null
		} else {
			this.accordionMenuItem = accordionMenuItem
		}

		//NOTE questo genera un'eccezione in questo punto, non usarlo
		//this.changeDetector.detectChanges();
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts